enum ProductClassType {
  SINGLE = 'SINGLE',
  SUPPLEMENTED = 'SUPPLEMENTED',
  OPTIONAL = 'OPTIONAL',
  PRICING_OPTIONAL = 'PRICING_OPTIONAL',
}

namespace ProductClassType {
  const values = {
    SINGLE: {
      name: '단일상품',
      reviewWritable: true,
    },
    SUPPLEMENTED: {
      name: '추가구성상품',
      reviewWritable: false,
    },
    OPTIONAL: {
      name: '옵션상품',
      reviewWritable: true,
    },
    PRICING_OPTIONAL: {
      name: '조합형옵션상품',
      reviewWritable: true,
    },
  }

  export const getName = (type: ProductClassType): string => {
    return values[type] && values[type].name
  }

  export const isReviewWritable = (type: ProductClassType): boolean => {
    return values[type] && values[type].reviewWritable
  }
}

export default ProductClassType
